import React from "react";
import "./Value.css";
import Logo02 from "../../../images/logo.jpg";

const valuePoints = [
  {
    icon: "home-outline",
    text: "Transition from non-critical unnecessary hospital visits to expert doctor and full healthcare services from the comfort of your home, marketplace, and work environment.",
  },
  {
    icon: "wallet-outline",
    text: "Our services save you from excessive financial costs resulting from unnecessary admissions, transport, traffic jam, and waiting time stress.",
  },
  {
    icon: "shield-checkmark-outline",
    text: "Our Preventive Healthcare Promotion packages offer screening services which enable early diagnosis of both communicable and non-communicable diseases.",
  },
  {
    icon: "trending-down-outline",
    text: "Very affordable, accessible services compared to hospital-based care - you pay only for direct costs: doctor, nurses, laboratory, and pharmacy services.",
  },
];

export default function Value() {
  return (
    <section className="value-section" aria-labelledby="value-heading">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Left: Image */}
          <div
            className="col-lg-5 col-md-12 value-img-col"
            data-aos="fade-right"
          >
            <div className="value-img-wrapper">
              <img src={Logo02} alt="Yita Life Doctor Services" />
              <div className="value-img-caption">
                <div className="stat-num">1,000+</div>
                <div className="stat-label">Patients Served</div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="col-lg-7 col-md-12" data-aos="fade-left">
            <div className="value-tag">
              <ion-icon name="star-outline"></ion-icon>
              Why Choose Yita Life
            </div>
            <h2 className="value-heading" id="value-heading">
              The Smart Choice for <br /> Quality Healthcare
            </h2>
            <p className="value-subtitle">
              We resolve hospital congestion, excessive waiting time, and
              travel pressure - all at an affordable cost.
            </p>

            <ul className="value-list" style={{ marginTop: "28px" }}>
              {valuePoints.map((item, i) => (
                <li
                  className="value-list-item"
                  key={i}
                  data-aos="fade-left"
                  data-aos-delay={i * 80}
                >
                  <div className="value-icon">
                    <ion-icon name={item.icon}></ion-icon>
                  </div>
                  <p>{item.text}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
